import { useNavigate, useLocation, useParams } from "react-router-dom";

export default function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        match={{ params }}
        history={{ push: navigate, location }}
        location={location}
      />
    );
  }

  return ComponentWithRouterProp;
}
